import { Typography } from '@mui/material';
import { ModalPageTemplate } from '@karehero/llama/pwa/templates/ModalPageTemplate/ModalPageTemplate';
import { useGoBack } from 'hooks/useGoBack';

export const BenefitsEligibilityV2Complete = () => {
  const goBack = useGoBack();

  return (
    <ModalPageTemplate onBack={goBack}>
      <Typography variant='h2'>Benefits Results V2</Typography>
      <Typography variant='body2'>Coming soon</Typography>
    </ModalPageTemplate>
  );
};

export default BenefitsEligibilityV2Complete;
